import { Injectable } from '@angular/core';
import { Print } from '../models/Print';
import { Style } from '../models/Style';
import { Region } from '../models/Region';
import { Orientation } from '../models/Orientation';
import { Size } from '../models/Size';
import { StyleService } from '../services/style.service';

@Injectable()
export class PrintService {
  prints: Print[];

  constructor(private styleService: StyleService) {
    // return some harcoded prints for now
    const styles: Style[] = styleService.list();
    const europe: Region = { name: 'EU', unit: 'cm' };
    const us: Region = { name: 'US', unit: 'in' };

    this.prints = [
      {
        id: 'CUSTOM10X10',
        name: 'CUSTOM10X10',
        sizes: [{ width: 10, height: 10, unit: 'in', orientation: 'square' }],
        styles,
        frames: [],
        region: us
      },
      {
        id: 'CUSTOM12X12',
        name: 'CUSTOM12X12',
        sizes: [{ width: 12, height: 12, unit: 'in', orientation: 'square' }],
        styles,
        frames: [
          {
            id: 'FRAMEGLOBAL12X12INCHWOODBLACK',
            name: { en: 'Frame 12 x 12 inch - wood black', de: 'Rahmen 12 x 12 Zoll - Holz schwarz' }
          },
          {
            id: 'FRAMEGLOBAL12X12INCHWOODNATURAL',
            name: { en: 'Frame 12 x 12 inch - wood natural', de: 'Rahmen 12 x 12 Zoll - Holz natur' }
          },
          {
            id: 'FRAMEGLOBAL12X12INCHWOODWHITE',
            name: { en: 'Frame 12 x 12 inch - wood white', de: 'Rahmen 12 x 12 Zoll - Holz weiß' }
          }
        ],
        region: us
      },
      {
        id: 'CUSTOM16X16',
        name: 'CUSTOM16X16',
        sizes: [{ width: 16, height: 16, unit: 'in', orientation: 'square' }],
        styles,
        frames: [],
        region: us
      },
      {
        id: 'CUSTOM18X24',
        name: 'CUSTOM18X24',
        sizes: [
          { width: 18, height: 24, unit: 'in', orientation: 'portrait' },
          { width: 24, height: 18, unit: 'in', orientation: 'landscape' }
        ],
        styles,
        frames: [
          {
            id: 'FRAMEGLOBAL18X24INCHWOODBLACK',
            name: { en: 'Frame 18 x 24 inch - wood black', de: 'Rahmen 18 x 24 Zoll - Holz schwarz' }
          },
          {
            id: 'FRAMEGLOBAL18X24INCHWOODNATURAL',
            name: { en: 'Frame 18 x 24 inch - wood natural', de: 'Rahmen 18 x 24 Zoll - Holz natur' }
          },
          {
            id: 'FRAMEGLOBAL18X24INCHWOODWHITE',
            name: { en: 'Frame 18 x 24 inch - wood white', de: 'Rahmen 18 x 24 Zoll - Holz weiß' }
          }
        ],
        region: us
      },
      {
        id: 'CUSTOM24X36',
        name: 'CUSTOM24X36',
        sizes: [
          { width: 24, height: 36, unit: 'in', orientation: 'portrait' },
          { width: 36, height: 24, unit: 'in', orientation: 'landscape' }
        ],
        styles,
        frames: [
          {
            id: 'FRAMEGLOBAL24X36INCHWOODBLACK',
            name: { en: 'Frame 24 x 36 inch - wood black', de: 'Rahmen 24 x 36 Zoll - Holz schwarz' }
          },
          {
            id: 'FRAMEGLOBAL24X36INCHWOODNATURAL',
            name: { en: 'Frame 24 x 36 inch - wood natural', de: 'Rahmen 24 x 36 Zoll - Holz natur' }
          },
          {
            id: 'FRAMEGLOBAL24X36INCHWOODWHITE',
            name: { en: 'Frame 24 x 36 inch - wood white', de: 'Rahmen 24 x 36 Zoll - Holz weiß' }
          }
        ],
        region: us
      },
      {
        id: 'CUSTOM25X25',
        name: 'CUSTOM25X25',
        sizes: [{ width: 25, height: 25, unit: 'cm', orientation: 'square' }],
        styles,
        frames: [],
        region: europe
      },
      {
        id: 'CUSTOM30X30',
        name: 'CUSTOM30X30',
        sizes: [{ width: 30, height: 30, unit: 'cm', orientation: 'square' }],
        styles,
        frames: [
          {
            id: 'FRAMEGLOBAL30X30CMWOODBLACK',
            name: { en: 'Frame 30 x 30 cm - wood black', de: 'Rahmen 30 x 30 cm - Holz schwarz' }
          },
          {
            id: 'FRAMEGLOBAL30X30CMWOODNATURAL',
            name: { en: 'Frame 30 x 30 cm - wood natural', de: 'Rahmen 30 x 30 cm - Holz natur' }
          },
          {
            id: 'FRAMEGLOBAL30X30CMWOODWHITE',
            name: { en: 'Frame 30 x 30 cm - wood white', de: 'Rahmen 30 x 30 cm - Holz weiß' }
          }
        ],
        region: europe
      },
      {
        id: 'CUSTOM40X40',
        name: 'CUSTOM40X40',
        sizes: [{ width: 40, height: 40, unit: 'cm', orientation: 'square' }],
        styles,
        frames: [],
        region: europe
      },
      {
        id: 'CUSTOM50X70',
        name: 'CUSTOM50X70',
        sizes: [
          { width: 50, height: 70, unit: 'cm', orientation: 'portrait' },
          { width: 70, height: 50, unit: 'cm', orientation: 'landscape' }
        ],
        styles,
        frames: [
          {
            id: 'FRAMEGLOBAL50X70CMWOODBLACK',
            name: { en: 'Frame 50 x 70 cm - wood black', de: 'Rahmen 50 x 70 cm - Holz schwarz' }
          },
          {
            id: 'FRAMEGLOBAL50X70CMWOODNATURAL',
            name: { en: 'Frame 50 x 70 cm - wood natural', de: 'Rahmen 50 x 70 cm - Holz natur' }
          },
          {
            id: 'FRAMEGLOBAL50X70CMWOODWHITE',
            name: { en: 'Frame 50 x 70 cm - wood white', de: 'Rahmen 50 x 70 cm - Holz weiß' }
          }
        ],
        region: europe
      },
      {
        id: 'CUSTOM61X91',
        name: 'CUSTOM61X91',
        sizes: [
          { width: 61, height: 91, unit: 'cm', orientation: 'portrait' },
          { width: 91, height: 61, unit: 'cm', orientation: 'landscape' }
        ],
        styles,
        frames: [
          {
            id: 'FRAMEGLOBAL61X91CMWOODBLACK',
            name: { en: 'Frame 61 x 91 cm - wood black', de: 'Rahmen 61 x 91 cm - Holz schwarz' }
          },
          {
            id: 'FRAMEGLOBAL61X91CMWOODNATURAL',
            name: { en: 'Frame 61 x 91 cm - wood natural', de: 'Rahmen 61 x 91 cm - Holz natur' }
          },
          {
            id: 'FRAMEGLOBAL61X91CMWOODWHITE',
            name: { en: 'Frame 61 x 91 cm - wood white', de: 'Rahmen 61 x 91 cm - Holz weiß' }
          }
        ],
        region: europe
      },
      {
        id: 'CUSTOM70X100',
        name: 'CUSTOM70X100',
        sizes: [
          { width: 70, height: 100, unit: 'cm', orientation: 'portrait' },
          { width: 100, height: 70, unit: 'cm', orientation: 'landscape' }
        ],
        styles,
        frames: [
          {
            id: 'FRAMEGLOBAL70X100CMWOODBLACK',
            name: { en: 'Frame 70 x 100 cm - wood black', de: 'Rahmen 70 x 100 cm - Holz schwarz' }
          },
          {
            id: 'FRAMEGLOBAL70X100CMWOODNATURAL',
            name: { en: 'Frame 70 x 100 cm - wood natural', de: 'Rahmen 70 x 100 cm - Holz natur' }
          },
          {
            id: 'FRAMEGLOBAL70X100CMWOODWHITE',
            name: { en: 'Frame 70 x 100 cm - wood white', de: 'Rahmen 70 x 100 cm - Holz weiß' }
          }
        ],
        region: europe
      }
    ];
  }

  list() {
    return this.prints;
  }

  listBy(region: Region, orientation: Orientation, style: Style) {
    return this.prints.filter(
      print =>
        print.region.name === region.name &&
        print.sizes.find(s => s.orientation === orientation) &&
        print.styles.find(s => s.id === style.id)
    );
  }

  getBySize(size: Size) {
    return this.prints.find(
      print =>
        !!print.sizes.find(
          s =>
            s.width === size.width &&
            s.height === size.height &&
            s.orientation === size.orientation &&
            s.unit === size.unit
        )
    );
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/services/print.service.ts